var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocketAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19.92 24.987-4.875-4.874m4.874 4.874a36.324 36.324 0 0 0 6.5-3.25m-6.5 3.25v8.125s4.924-.894 6.5-3.25c1.755-2.632 0-8.125 0-8.125m-11.374-1.624a35.753 35.753 0 0 1 3.25-6.419 20.93 20.93 0 0 1 17.873-9.83c0 4.42-1.267 12.186-9.75 17.873m-11.373-1.624H6.92s.894-4.924 3.25-6.5c2.632-1.755 8.124 0 8.124 0M7.733 27.424c-2.438 2.048-3.25 8.125-3.25 8.125s6.077-.813 8.124-3.25c1.154-1.365 1.138-3.46-.146-4.728a3.542 3.542 0 0 0-4.728-.147Z",
  stroke: "currentColor",
  strokeWidth: 3.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRocketAlt;